var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N158 - Gauges"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    d: "M12 4.8C16.56 4.8 20.4 8.52 20.4 13.2C20.4 15.72 19.26 18 17.52 19.56L15 17.04L15.84 16.2L17.46 17.82C18.42 16.68 19.02 15.3 19.14 13.8H16.8V12.6H19.2C19.08 11.04 18.48 9.66 17.52 8.58L13.2 12.9C13.2 13.02 13.26 13.08 13.26 13.2C13.26 13.86 12.72 14.4 12.06 14.4C11.4 14.4 10.86 13.86 10.86 13.2C10.86 12.54 11.4 12 12.06 12C12.18 12 12.24 12 12.36 12.06L16.68 7.74C15.54 6.78 14.16 6.18 12.66 6.06V8.4H11.46V6.06C9.89998 6.18 8.51998 6.78 7.43998 7.74L9.05998 9.36L8.15998 10.2L6.53998 8.58C5.57998 9.66 4.97998 11.04 4.79998 12.6H7.19998V13.8H4.85998C4.97998 15.36 5.57998 16.74 6.53998 17.82L8.15998 16.2L8.99998 17.04L6.47998 19.56C4.73998 18 3.59998 15.72 3.59998 13.2C3.59998 8.52 7.43998 4.8 12 4.8Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeIcon);
export default __webpack_public_path__ + "static/media/gauge-icon.aab29127aaa8f6eaa504a4ccdf4c3d82.svg";
export { ForwardRef as ReactComponent };